import { axios } from '../lib/axios';

export async function putExistingMarkive(data) {
  document.getElementById("create-markive-button").setAttribute("disabled", "disabled");

  await axios.put(`/api/update-markive/${data.id}`, data);
}
